import createReactComponent from '../createReactComponent';
export default createReactComponent('circle-letter-h', 'IconCircleLetterH', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M10 16v-8m4 0v8', key: 'svg-1' }],
  ['path', { d: 'M10 12h4', key: 'svg-2' }],
]);
